import styled, { css } from 'styled-components';
import { color, container, fontSize, screen, spacing } from '../../theme';
import { Heading2 } from '../shared/Typography';

const sectionVariants: {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  [key: string]: { backgroundColor: string | ((props: any) => any) };
} = {
  alt: {
    backgroundColor: color('sand_100')
  }
};

export const StyledJobOfferSection = styled.section<{ sectionBg?: string }>`
  background-color: ${color('white')};
  padding-top: ${spacing('xl3')};
  padding-bottom: ${spacing('xl3')};

  @media (min-width: ${screen('lg')}) {
    padding-top: ${spacing('xl4')};
    padding-bottom: ${spacing('xl4')};
  }

  ${({ sectionBg }) =>
    sectionBg &&
    sectionVariants[sectionBg] &&
    css`
      background-color: ${sectionVariants[sectionBg].backgroundColor};
    `}
`;

export const StyledJobOfferSectionContainer = styled.div`
  margin: auto;
  max-width: calc(${container('lg')} + ${spacing('md')} * 2);
  padding-left: ${spacing('md')};
  padding-right: ${spacing('md')};
`;

export const StyledJobOfferSectionHeader = styled.header`
  text-align: center;
  margin-top: ${spacing('sm')};
  margin-bottom: ${spacing('lg')};
`;

export const StyledJobOfferSectionTitle = styled(Heading2)``;

export const StyledJobOfferSectionIntro = styled.div`
  font-size: ${fontSize('md')};
  margin-bottom: 0;
  margin-top: ${spacing('lg')};

  @media (min-width: ${screen('md')}) {
    margin-top: ${spacing('xl')};
  }

  @media (min-width: ${screen('lg')}) {
    font-size: ${fontSize('lg')};
    margin-top: ${spacing('xl3')};
  }
`;
